// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== Main ========== */



.sidebar__section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px 8px;
}

.sidebar__section-title {
    font-size: 11px;
    font-weight: 600;
    color: var(--text-tertiary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.sidebar__section-btn {
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    border-radius: var(--radius-md);
    cursor: pointer;
    color: var(--text-tertiary);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.sidebar__section-btn:hover {
    background: var(--gray-100);
    color: var(--partner-primary-600);
}

.sidebar__list {
    flex: 1 1;
    overflow-y: auto;
    padding: 0 8px;
}

.course-item-sidebar {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-radius: var(--radius-md);
    cursor: pointer;
    transition: all 0.2s;
    margin-bottom: 2px;
}

.course-item-sidebar:hover {
    background: var(--surface);
}

.course-item-sidebar--active {
    background: var(--partner-primary-50);
}

.course-item-sidebar__icon {
    width: 32px;
    height: 32px;
    border-radius: var(--radius-md);
    background: var(--gray-100);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-tertiary);
    flex-shrink: 0;
}

.course-item-sidebar--active .course-item-sidebar__icon {
    background: var(--partner-primary-100);
    color: var(--partner-primary-600);
}

.course-item-sidebar__info {
    flex: 1 1;
    min-width: 0;
}

.course-item-sidebar__title {
    font-size: 13px;
    font-weight: 500;
    color: var(--text-primary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.course-item-sidebar__meta {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 2px;
}

.course-item-sidebar__count {
    font-size: 11px;
    color: var(--text-tertiary);
}

.course-item-sidebar__status {
    font-size: 10px;
    font-weight: 500;
    padding: 1px 6px;
    border-radius: var(--radius-sm);
}

.course-item-sidebar__status--active {
    background: var(--success-light);
    color: var(--success);
}

.course-item-sidebar__status--upcoming {
    background: var(--warning-light);
    color: #d97706;
}

.course-item-sidebar__status--ended {
    background: var(--gray-100);
    color: var(--gray-500);
}








.main-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 20px;
    background: var(--background);
    border-bottom: 1px solid var(--border);
}

.main-header__title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
}

.main-header__right {
    display: flex;
    align-items: center;
    gap: 8px;
}

.main-header__btn {
    width: 36px;
    height: 36px;
    border: 1px solid var(--border);
    background: var(--background);
    border-radius: var(--radius-md);
    cursor: pointer;
    color: var(--text-secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.main-header__btn:hover {
    background: var(--surface);
    border-color: var(--partner-primary-300);
    color: var(--partner-primary-600);
}

.partner-btn--primary {
    background: var(--partner-primary-600);
    color: white;
    transition: background-color var(--transition-fast);
}

.partner-btn--primary:hover {
    background: var(--partner-primary-700);
}

.btn--secondary {
    background: var(--background);
    border: 1px solid var(--border);
    color: var(--text-primary);
}

.btn--secondary:hover {
    background: var(--surface);
    border-color: var(--partner-primary-300);
}

.main-content {
    flex: 1 1;
    overflow-y: auto;
    padding: 20px;
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    margin-bottom: 20px;
}

@media (max-width: 1200px) {
    .stats-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

.stat-card {
    background: var(--background);
    border: 1px solid var(--border);
    border-radius: var(--radius-lg);
    padding: 16px;
}

.stat-card__icon {
    width: 36px;
    height: 36px;
    border-radius: var(--radius-md);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
}

.stat-card__icon--primary {
    background: var(--partner-primary-100);
    color: var(--partner-primary-600);
}

.stat-card__icon--success {
    background: var(--success-light);
    color: var(--success);
}

.stat-card__icon--warning {
    background: var(--warning-light);
    color: var(--warning);
}

.stat-card__icon--purple {
    background: var(--primary-100);
    color: var(--primary-600);
}

.stat-card__label {
    font-size: 12px;
    color: var(--text-tertiary);
    margin-bottom: 4px;
}

.stat-card__value {
    font-size: 24px;
    font-weight: 700;
    color: var(--text-primary);
}

.stat-card__change {
    font-size: 11px;
    color: var(--text-tertiary);
    margin-top: 4px;
}

.card {
    background: var(--background);
    border: 1px solid var(--border);
    border-radius: var(--radius-lg);
}

.card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid var(--border);
}

.card__title {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
    display: flex;
    align-items: center;
    gap: 8px;
}

.filters {
    display: flex;
    gap: 8px;
}

.filter-select {
    padding: 6px 10px;
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    font-size: 12px;
    background: var(--background);
}

.filter-search {
    position: relative;
}

.filter-search__icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--text-tertiary);
}

.filter-search__input {
    padding: 6px 10px 6px 32px;
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    font-size: 12px;
    width: 180px;
}

.course-list {
    display: flex;
    flex-direction: column;
}

.course-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 20px;
    border-bottom: 1px solid var(--border);
    cursor: pointer;
    transition: all 0.2s;
}

.course-item:last-child {
    border-bottom: none;
}

.course-item:hover {
    background: var(--partner-primary-50);
}

.course-item__icon {
    width: 44px;
    height: 44px;
    border-radius: var(--radius-lg);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.course-item__icon--active {
    background: var(--partner-primary-600);
    color: white;
}

.course-item__icon--upcoming {
    background: var(--warning);
    color: white;
}

.course-item__icon--ended {
    background: var(--gray-200);
    color: var(--gray-500);
}

.course-item__info {
    flex: 1 1;
    min-width: 0;
}

.course-item__name {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 4px;
}

.course-item__meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    font-size: 12px;
    color: var(--text-secondary);
}

.course-item__meta-item {
    display: flex;
    align-items: center;
    gap: 4px;
}

.course-item__code {
    font-family: monospace;
    font-weight: 600;
    color: var(--partner-primary-600);
    background: var(--partner-primary-50);
    padding: 2px 6px;
    border-radius: var(--radius-sm);
}

.course-item__stats {
    display: flex;
    gap: 20px;
}

.course-item__stat {
    text-align: center;
    min-width: 50px;
}

.course-item__stat-value {
    font-size: 16px;
    font-weight: 700;
    color: var(--text-primary);
}

.course-item__stat-label {
    font-size: 10px;
    color: var(--text-tertiary);
}

.course-item__status {
    padding: 4px 10px;
    border-radius: var(--radius-full);
    font-size: 11px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 4px;
}

.course-item__status--active {
    background: var(--success-light);
    color: var(--success);
}

.course-item__status--upcoming {
    background: var(--warning-light);
    color: #d97706;
}

.course-item__status--ended {
    background: var(--gray-100);
    color: var(--gray-500);
}

.course-item__status-dot {
    width: 6px;
    height: 6px;
    border-radius: var(--radius-full);
    background: currentColor;
}

.course-item__actions {
    display: flex;
    gap: 4px;
    opacity: 0;
    transition: opacity 0.2s;
}

.course-item:hover .course-item__actions {
    opacity: 1;
}

.course-item__action {
    width: 32px;
    height: 32px;
    border: 1px solid var(--border);
    background: var(--background);
    border-radius: var(--radius-md);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-tertiary);
    transition: all 0.2s;
}

.course-item__action:hover {
    background: var(--partner-primary-50);
    border-color: var(--partner-primary-300);
    color: var(--partner-primary-600);
}


.partner-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s;
}

.partner-modal-overlay--open {
    opacity: 1;
    visibility: visible;
}

.partner-modal {
    background: var(--background);
    border-radius: 12px;
    width: 100%;
    max-width: 520px;
    max-height: 90vh;
    overflow: hidden;
    transform: scale(0.95);
    transition: all 0.3s;
}

.partner-modal-overlay--open .partner-modal {
    transform: scale(1);
}

.partner-modal__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid var(--border);
}

.partner-modal__title {
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
}

.partner-modal__close {
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    border-radius: var(--radius-md);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-tertiary);
}

.partner-modal__close:hover {
    background: var(--gray-100);
    color: var(--text-primary);
}

.partner-modal__body {
    padding: 20px;
    max-height: 60vh;
    overflow-y: auto;
}

.partner-modal__footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 16px 20px;
    border-top: 1px solid var(--border);
    background: var(--gray-50);
}

.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

/* 자동완성 드롭다운 */
.autocomplete-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1000;
    background: var(--background);
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    margin-top: 4px;
    max-height: 200px;
    overflow-y: auto;
    animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-4px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.autocomplete-item {
    padding: 10px 12px;
    font-size: 13px;
    color: var(--text-primary);
    cursor: pointer;
    transition: all 0.15s;
    border-bottom: 1px solid var(--border);
}

.autocomplete-item:last-child {
    border-bottom: none;
}

.autocomplete-item:hover,
.autocomplete-item--selected {
    background: var(--partner-primary-50);
    color: var(--partner-primary-700);
}

.autocomplete-item:active {
    background: var(--partner-primary-100);
}

/* 교육 기간 정보 */
.training-days-info {
    margin-top: 8px;
    padding: 10px 12px;
    background: var(--partner-primary-50);
    border: 1px solid var(--partner-primary-200);
    border-radius: var(--radius-md);
    font-size: 13px;
    color: var(--text-secondary);
    display: flex;
    align-items: center;
    gap: 4px;
}

.training-days-info strong {
    color: var(--partner-primary-700);
    font-weight: 600;
    font-size: 14px;
}

.llm-grid__header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 8px;
}

.llm-select-all-btn {
    padding: 4px 12px;
    font-size: 12px;
    font-weight: 600;
    color: var(--partner-primary-500);
    background: var(--partner-primary-50);
    border: 1px solid var(--partner-primary-200);
    border-radius: var(--radius-md);
    cursor: pointer;
    transition: all 0.2s;
    font-family: var(--font-sans);
}

.llm-select-all-btn:hover {
    background: var(--partner-primary-100);
}

.llm-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

.llm-option {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px;
    border: 2px solid var(--border);
    border-radius: var(--radius-lg);
    cursor: pointer;
    transition: all 0.2s;
    min-height: 56px;
    box-sizing: border-box;
}

.llm-option:hover {
    border-color: var(--partner-primary-300);
    background: var(--partner-primary-50);
}

.llm-option--selected {
    border-color: var(--partner-primary-500);
    background: var(--partner-primary-50);
}

.llm-option__checkbox {
    width: 18px;
    height: 18px;
    border: 2px solid var(--border);
    border-radius: var(--radius-sm);
    display: flex;
    align-items: center;
    justify-content: center;
}

.llm-option--selected .llm-option__checkbox {
    background: var(--partner-primary-500);
    border-color: var(--partner-primary-500);
    color: white;
}

.llm-option__icon {
    width: 32px;
    height: 32px;
    border-radius: var(--radius-md);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    color: white;
}

.llm-option__icon--gpt {
    background: var(--gpt-color);
}

.llm-option__icon--claude {
    background: var(--claude-color);
}

.llm-option__icon--gemini {
    background: var(--gemini-color);
}

.llm-option__icon--exaone {
    background: var(--exaone-color);
}
.llm-option__icon--meta { background: var(--meta-color); }
.llm-option__icon--stepfun { background: var(--stepfun-color); }
.llm-option__icon--upstage { background: var(--upstage-color); }
.llm-option__icon--nvidia { background: var(--nvidia-color); }
.llm-option__icon--arcee { background: var(--arcee-color); }
.llm-option__icon--qwen { background: var(--qwen-color); }
.llm-option__icon--mistral { background: var(--mistral-color); }
.llm-option__icon--deepseek { background: var(--deepseek-color); }

.llm-option__name {
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 140px;
}

.llm-option__desc {
    font-size: 11px;
    color: var(--text-tertiary);
}

.cost-estimate {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius-lg);
    padding: 14px;
    margin-top: 16px;
}

.cost-estimate__title {
    font-size: 12px;
    font-weight: 600;
    color: var(--text-secondary);
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.cost-estimate__row {
    display: flex;
    justify-content: space-between;
    padding: 6px 0;
    font-size: 12px;
}

.cost-estimate__row--total {
    border-top: 1px solid var(--border);
    margin-top: 8px;
    padding-top: 10px;
    font-weight: 600;
}

.cost-estimate__label {
    color: var(--text-secondary);
}

.cost-estimate__value {
    font-weight: 500;
}

.cost-estimate__row--total .cost-estimate__value {
    color: var(--partner-primary-600);
    font-size: 14px;
}

.success-content {
    text-align: center;
    padding: 16px 0;
}

.success-content__icon {
    width: 64px;
    height: 64px;
    background: var(--success-light);
    border-radius: var(--radius-full);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
    color: var(--success);
}

.success-content__title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 4px;
}

.success-content__subtitle {
    font-size: 13px;
    color: var(--text-secondary);
}

.invite-section {
    margin-top: 20px;
    text-align: left;
}

.invite-section__label {
    font-size: 11px;
    font-weight: 600;
    color: var(--text-tertiary);
    text-transform: uppercase;
    margin-bottom: 6px;
}

.invite-section__code {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    background: var(--partner-primary-50);
    border: 2px solid var(--partner-primary-200);
    border-radius: var(--radius-lg);
    margin-bottom: 12px;
}

.invite-section__code-text {
    flex: 1 1;
    font-size: 24px;
    font-weight: 700;
    font-family: monospace;
    letter-spacing: 3px;
    color: var(--partner-primary-600);
    text-align: center;
}

.invite-section__url {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    background: var(--gray-50);
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
}

.invite-section__url input {
    flex: 1 1;
    border: none;
    background: transparent;
    font-size: 12px;
    font-family: monospace;
    color: var(--text-secondary);
}

.info-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    margin-top: 16px;
    padding: 14px;
    background: var(--surface);
    border-radius: var(--radius-lg);
}

.info-grid__item {
    text-align: center;
}

.info-grid__value {
    font-size: 16px;
    font-weight: 700;
}

.info-grid__label {
    font-size: 10px;
    color: var(--text-tertiary);
    margin-top: 2px;
}

/* Dropdown Menu */
.dropdown-menu {
    position: fixed;
    background: var(--background);
    border: 1px solid var(--border);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-lg);
    min-width: 180px;
    z-index: 1001;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-8px);
    transition: all 0.2s;
}

.dropdown-menu--open {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}

.dropdown-menu__item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    font-size: 13px;
    color: var(--text-primary);
    cursor: pointer;
    transition: all 0.15s;
}

.dropdown-menu__item:first-child {
    border-radius: var(--radius-lg) var(--radius-lg) 0 0;
}

.dropdown-menu__item:last-child {
    border-radius: 0 0 var(--radius-lg) var(--radius-lg);
}

.dropdown-menu__item:hover {
    background: var(--partner-primary-50);
    color: var(--partner-primary-600);
}

.dropdown-menu__item--danger:hover {
    background: var(--error-alert-bg);
    color: var(--error);
}

.dropdown-menu__divider {
    height: 1px;
    background: var(--border);
    margin: 4px 0;
}

/* Header Right Actions */
.main-header__right {
    display: flex;
    align-items: center;
    gap: 8px;
}

.main-header__btn {
    width: 36px;
    height: 36px;
    border: 1px solid var(--border);
    background: var(--background);
    border-radius: var(--radius-md);
    cursor: pointer;
    color: var(--text-secondary);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.main-header__btn:hover {
    background: var(--surface);
    border-color: var(--partner-primary-300);
    color: var(--partner-primary-600);
}

.main-header__badge {
    position: absolute;
    top: -4px;
    right: -4px;
    min-width: 18px;
    height: 18px;
    background: var(--error);
    color: white;
    font-size: 10px;
    font-weight: 600;
    border-radius: var(--radius-full);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 4px;
}

/* Notification Dropdown */
.notification-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    width: 320px;
    background: var(--background);
    border: 1px solid var(--border);
    border-radius: var(--radius-lg);
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    display: none;
}

.notification-dropdown--open {
    display: block;
}

.notification-dropdown__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid var(--border);
}

.notification-dropdown__title {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
}

.notification-dropdown__action {
    font-size: 12px;
    color: var(--partner-primary-600);
    cursor: pointer;
}

.notification-dropdown__action:hover {
    text-decoration: underline;
}

.notification-dropdown__list {
    max-height: 360px;
    overflow-y: auto;
}

.notification-dropdown__empty {
    padding: 40px 20px;
    text-align: center;
    color: var(--text-tertiary);
    font-size: 13px;
}

.notification-dropdown__footer {
    padding: 10px 16px;
    border-top: 1px solid var(--border);
    text-align: center;
}

.notification-dropdown__footer a {
    font-size: 12px;
    color: var(--partner-primary-600);
    text-decoration: none;
}

.notification-dropdown__footer a:hover {
    text-decoration: underline;
}

.notification-item {
    padding: 12px 16px;
    border-bottom: 1px solid var(--border);
    cursor: pointer;
    transition: background 0.15s;
}

.notification-item:hover {
    background: var(--surface);
}

.notification-item:last-child {
    border-bottom: none;
}

.notification-item--unread {
    background: var(--partner-primary-50);
}

.notification-item--unread:hover {
    background: var(--partner-primary-100);
}

.notification-item__text {
    font-size: 13px;
    color: var(--text-primary);
    line-height: 1.5;
}

.notification-item__text strong {
    font-weight: 600;
}

.notification-item__time {
    font-size: 11px;
    color: var(--text-tertiary);
    margin-top: 4px;
}

.notification-group {
    padding: 8px 16px 4px;
    font-size: 11px;
    font-weight: 600;
    color: var(--text-tertiary);
    text-transform: uppercase;
    background: var(--surface);
}`, "",{"version":3,"sources":["webpack://./src/css/PartnerProjectManagement.css"],"names":[],"mappings":"AAAA,+BAA+B;;;;AAI/B;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,+BAA+B;IAC/B,eAAe;IACf,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,iCAAiC;AACrC;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe;IACf,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;AAC1B;;;;;;;;;AASA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,6BAA6B;IAC7B,+BAA+B;IAC/B,eAAe;IACf,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,wCAAwC;IACxC,iCAAiC;AACrC;;AAEA;IACI,sCAAsC;IACtC,YAAY;IACZ,mDAAmD;AACvD;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,+BAA+B;IAC/B,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,+BAA+B;IAC/B,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,+BAA+B;IAC/B,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,iCAAiC;IACjC,qCAAqC;IACrC,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iCAAiC;IACjC,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,6BAA6B;IAC7B,+BAA+B;IAC/B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,qCAAqC;IACrC,wCAAwC;IACxC,iCAAiC;AACrC;;;AAGA;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,+BAA+B;IAC/B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,QAAQ;IACR,kBAAkB;IAClB,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,6BAA6B;IAC7B,+BAA+B;IAC/B,+BAA+B;IAC/B,yCAAyC;IACzC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,qBAAqB;IACrB,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,qCAAqC;IACrC,iCAAiC;AACrC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,aAAa;AACb;IACI,eAAe;IACf,kBAAkB;IAClB,qCAAqC;IACrC,4CAA4C;IAC5C,+BAA+B;IAC/B,eAAe;IACf,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,qCAAqC;IACrC,4CAA4C;IAC5C,+BAA+B;IAC/B,eAAe;IACf,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,+BAA+B;IAC/B,+BAA+B;IAC/B,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,wCAAwC;IACxC,qCAAqC;AACzC;;AAEA;IACI,wCAAwC;IACxC,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;IACtC,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;AACA,0BAA0B,6BAA6B,EAAE;AACzD,6BAA6B,gCAAgC,EAAE;AAC/D,6BAA6B,gCAAgC,EAAE;AAC/D,4BAA4B,+BAA+B,EAAE;AAC7D,2BAA2B,8BAA8B,EAAE;AAC3D,0BAA0B,6BAA6B,EAAE;AACzD,6BAA6B,gCAAgC,EAAE;AAC/D,8BAA8B,iCAAiC,EAAE;;AAEjE;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,+BAA+B;IAC/B,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC,4CAA4C;IAC5C,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,0BAA0B;IAC1B,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,6BAA6B;IAC7B,+BAA+B;IAC/B,+BAA+B;IAC/B,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,qCAAqC;IACrC,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;AACjB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,6BAA6B;IAC7B,+BAA+B;IAC/B,eAAe;IACf,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,wCAAwC;IACxC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,YAAY;IACZ,wBAAwB;IACxB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,YAAY;IACZ,6BAA6B;IAC7B,+BAA+B;IAC/B,+BAA+B;IAC/B,2CAA2C;IAC3C,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,yBAAyB;IACzB,0BAA0B;AAC9B","sourcesContent":["/* ========== Main ========== */\n\n\n\n.sidebar__section-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 16px 8px;\n}\n\n.sidebar__section-title {\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--text-tertiary);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.sidebar__section-btn {\n    width: 28px;\n    height: 28px;\n    border: none;\n    background: transparent;\n    border-radius: var(--radius-md);\n    cursor: pointer;\n    color: var(--text-tertiary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s;\n}\n\n.sidebar__section-btn:hover {\n    background: var(--gray-100);\n    color: var(--partner-primary-600);\n}\n\n.sidebar__list {\n    flex: 1;\n    overflow-y: auto;\n    padding: 0 8px;\n}\n\n.course-item-sidebar {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 12px;\n    border-radius: var(--radius-md);\n    cursor: pointer;\n    transition: all 0.2s;\n    margin-bottom: 2px;\n}\n\n.course-item-sidebar:hover {\n    background: var(--surface);\n}\n\n.course-item-sidebar--active {\n    background: var(--partner-primary-50);\n}\n\n.course-item-sidebar__icon {\n    width: 32px;\n    height: 32px;\n    border-radius: var(--radius-md);\n    background: var(--gray-100);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-tertiary);\n    flex-shrink: 0;\n}\n\n.course-item-sidebar--active .course-item-sidebar__icon {\n    background: var(--partner-primary-100);\n    color: var(--partner-primary-600);\n}\n\n.course-item-sidebar__info {\n    flex: 1;\n    min-width: 0;\n}\n\n.course-item-sidebar__title {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--text-primary);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.course-item-sidebar__meta {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-top: 2px;\n}\n\n.course-item-sidebar__count {\n    font-size: 11px;\n    color: var(--text-tertiary);\n}\n\n.course-item-sidebar__status {\n    font-size: 10px;\n    font-weight: 500;\n    padding: 1px 6px;\n    border-radius: var(--radius-sm);\n}\n\n.course-item-sidebar__status--active {\n    background: var(--success-light);\n    color: var(--success);\n}\n\n.course-item-sidebar__status--upcoming {\n    background: var(--warning-light);\n    color: #d97706;\n}\n\n.course-item-sidebar__status--ended {\n    background: var(--gray-100);\n    color: var(--gray-500);\n}\n\n\n\n\n\n\n\n\n.main-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 20px;\n    background: var(--background);\n    border-bottom: 1px solid var(--border);\n}\n\n.main-header__title {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.main-header__right {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.main-header__btn {\n    width: 36px;\n    height: 36px;\n    border: 1px solid var(--border);\n    background: var(--background);\n    border-radius: var(--radius-md);\n    cursor: pointer;\n    color: var(--text-secondary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s;\n}\n\n.main-header__btn:hover {\n    background: var(--surface);\n    border-color: var(--partner-primary-300);\n    color: var(--partner-primary-600);\n}\n\n.partner-btn--primary {\n    background: var(--partner-primary-600);\n    color: white;\n    transition: background-color var(--transition-fast);\n}\n\n.partner-btn--primary:hover {\n    background: var(--partner-primary-700);\n}\n\n.btn--secondary {\n    background: var(--background);\n    border: 1px solid var(--border);\n    color: var(--text-primary);\n}\n\n.btn--secondary:hover {\n    background: var(--surface);\n    border-color: var(--partner-primary-300);\n}\n\n.main-content {\n    flex: 1;\n    overflow-y: auto;\n    padding: 20px;\n}\n\n.stats-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 16px;\n    margin-bottom: 20px;\n}\n\n@media (max-width: 1200px) {\n    .stats-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n.stat-card {\n    background: var(--background);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-lg);\n    padding: 16px;\n}\n\n.stat-card__icon {\n    width: 36px;\n    height: 36px;\n    border-radius: var(--radius-md);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 8px;\n}\n\n.stat-card__icon--primary {\n    background: var(--partner-primary-100);\n    color: var(--partner-primary-600);\n}\n\n.stat-card__icon--success {\n    background: var(--success-light);\n    color: var(--success);\n}\n\n.stat-card__icon--warning {\n    background: var(--warning-light);\n    color: var(--warning);\n}\n\n.stat-card__icon--purple {\n    background: var(--primary-100);\n    color: var(--primary-600);\n}\n\n.stat-card__label {\n    font-size: 12px;\n    color: var(--text-tertiary);\n    margin-bottom: 4px;\n}\n\n.stat-card__value {\n    font-size: 24px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.stat-card__change {\n    font-size: 11px;\n    color: var(--text-tertiary);\n    margin-top: 4px;\n}\n\n.card {\n    background: var(--background);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-lg);\n}\n\n.card__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 20px;\n    border-bottom: 1px solid var(--border);\n}\n\n.card__title {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.filters {\n    display: flex;\n    gap: 8px;\n}\n\n.filter-select {\n    padding: 6px 10px;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    font-size: 12px;\n    background: var(--background);\n}\n\n.filter-search {\n    position: relative;\n}\n\n.filter-search__icon {\n    position: absolute;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--text-tertiary);\n}\n\n.filter-search__input {\n    padding: 6px 10px 6px 32px;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    font-size: 12px;\n    width: 180px;\n}\n\n.course-list {\n    display: flex;\n    flex-direction: column;\n}\n\n.course-item {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 16px 20px;\n    border-bottom: 1px solid var(--border);\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.course-item:last-child {\n    border-bottom: none;\n}\n\n.course-item:hover {\n    background: var(--partner-primary-50);\n}\n\n.course-item__icon {\n    width: 44px;\n    height: 44px;\n    border-radius: var(--radius-lg);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.course-item__icon--active {\n    background: var(--partner-primary-600);\n    color: white;\n}\n\n.course-item__icon--upcoming {\n    background: var(--warning);\n    color: white;\n}\n\n.course-item__icon--ended {\n    background: var(--gray-200);\n    color: var(--gray-500);\n}\n\n.course-item__info {\n    flex: 1;\n    min-width: 0;\n}\n\n.course-item__name {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n    margin-bottom: 4px;\n}\n\n.course-item__meta {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 12px;\n    font-size: 12px;\n    color: var(--text-secondary);\n}\n\n.course-item__meta-item {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.course-item__code {\n    font-family: monospace;\n    font-weight: 600;\n    color: var(--partner-primary-600);\n    background: var(--partner-primary-50);\n    padding: 2px 6px;\n    border-radius: var(--radius-sm);\n}\n\n.course-item__stats {\n    display: flex;\n    gap: 20px;\n}\n\n.course-item__stat {\n    text-align: center;\n    min-width: 50px;\n}\n\n.course-item__stat-value {\n    font-size: 16px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.course-item__stat-label {\n    font-size: 10px;\n    color: var(--text-tertiary);\n}\n\n.course-item__status {\n    padding: 4px 10px;\n    border-radius: var(--radius-full);\n    font-size: 11px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.course-item__status--active {\n    background: var(--success-light);\n    color: var(--success);\n}\n\n.course-item__status--upcoming {\n    background: var(--warning-light);\n    color: #d97706;\n}\n\n.course-item__status--ended {\n    background: var(--gray-100);\n    color: var(--gray-500);\n}\n\n.course-item__status-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: var(--radius-full);\n    background: currentColor;\n}\n\n.course-item__actions {\n    display: flex;\n    gap: 4px;\n    opacity: 0;\n    transition: opacity 0.2s;\n}\n\n.course-item:hover .course-item__actions {\n    opacity: 1;\n}\n\n.course-item__action {\n    width: 32px;\n    height: 32px;\n    border: 1px solid var(--border);\n    background: var(--background);\n    border-radius: var(--radius-md);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-tertiary);\n    transition: all 0.2s;\n}\n\n.course-item__action:hover {\n    background: var(--partner-primary-50);\n    border-color: var(--partner-primary-300);\n    color: var(--partner-primary-600);\n}\n\n\n.partner-modal-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.3s;\n}\n\n.partner-modal-overlay--open {\n    opacity: 1;\n    visibility: visible;\n}\n\n.partner-modal {\n    background: var(--background);\n    border-radius: 12px;\n    width: 100%;\n    max-width: 520px;\n    max-height: 90vh;\n    overflow: hidden;\n    transform: scale(0.95);\n    transition: all 0.3s;\n}\n\n.partner-modal-overlay--open .partner-modal {\n    transform: scale(1);\n}\n\n.partner-modal__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 20px;\n    border-bottom: 1px solid var(--border);\n}\n\n.partner-modal__title {\n    font-size: 16px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.partner-modal__close {\n    width: 32px;\n    height: 32px;\n    border: none;\n    background: transparent;\n    border-radius: var(--radius-md);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-tertiary);\n}\n\n.partner-modal__close:hover {\n    background: var(--gray-100);\n    color: var(--text-primary);\n}\n\n.partner-modal__body {\n    padding: 20px;\n    max-height: 60vh;\n    overflow-y: auto;\n}\n\n.partner-modal__footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    padding: 16px 20px;\n    border-top: 1px solid var(--border);\n    background: var(--gray-50);\n}\n\n.form-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n}\n\n/* 자동완성 드롭다운 */\n.autocomplete-dropdown {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    background: var(--background);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    margin-top: 4px;\n    max-height: 200px;\n    overflow-y: auto;\n    animation: fadeIn 0.2s ease-out;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-4px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.autocomplete-item {\n    padding: 10px 12px;\n    font-size: 13px;\n    color: var(--text-primary);\n    cursor: pointer;\n    transition: all 0.15s;\n    border-bottom: 1px solid var(--border);\n}\n\n.autocomplete-item:last-child {\n    border-bottom: none;\n}\n\n.autocomplete-item:hover,\n.autocomplete-item--selected {\n    background: var(--partner-primary-50);\n    color: var(--partner-primary-700);\n}\n\n.autocomplete-item:active {\n    background: var(--partner-primary-100);\n}\n\n/* 교육 기간 정보 */\n.training-days-info {\n    margin-top: 8px;\n    padding: 10px 12px;\n    background: var(--partner-primary-50);\n    border: 1px solid var(--partner-primary-200);\n    border-radius: var(--radius-md);\n    font-size: 13px;\n    color: var(--text-secondary);\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.training-days-info strong {\n    color: var(--partner-primary-700);\n    font-weight: 600;\n    font-size: 14px;\n}\n\n.llm-grid__header {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 8px;\n}\n\n.llm-select-all-btn {\n    padding: 4px 12px;\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--partner-primary-500);\n    background: var(--partner-primary-50);\n    border: 1px solid var(--partner-primary-200);\n    border-radius: var(--radius-md);\n    cursor: pointer;\n    transition: all 0.2s;\n    font-family: var(--font-sans);\n}\n\n.llm-select-all-btn:hover {\n    background: var(--partner-primary-100);\n}\n\n.llm-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 10px;\n}\n\n.llm-option {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 12px;\n    border: 2px solid var(--border);\n    border-radius: var(--radius-lg);\n    cursor: pointer;\n    transition: all 0.2s;\n    min-height: 56px;\n    box-sizing: border-box;\n}\n\n.llm-option:hover {\n    border-color: var(--partner-primary-300);\n    background: var(--partner-primary-50);\n}\n\n.llm-option--selected {\n    border-color: var(--partner-primary-500);\n    background: var(--partner-primary-50);\n}\n\n.llm-option__checkbox {\n    width: 18px;\n    height: 18px;\n    border: 2px solid var(--border);\n    border-radius: var(--radius-sm);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.llm-option--selected .llm-option__checkbox {\n    background: var(--partner-primary-500);\n    border-color: var(--partner-primary-500);\n    color: white;\n}\n\n.llm-option__icon {\n    width: 32px;\n    height: 32px;\n    border-radius: var(--radius-md);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    font-weight: 700;\n    color: white;\n}\n\n.llm-option__icon--gpt {\n    background: var(--gpt-color);\n}\n\n.llm-option__icon--claude {\n    background: var(--claude-color);\n}\n\n.llm-option__icon--gemini {\n    background: var(--gemini-color);\n}\n\n.llm-option__icon--exaone {\n    background: var(--exaone-color);\n}\n.llm-option__icon--meta { background: var(--meta-color); }\n.llm-option__icon--stepfun { background: var(--stepfun-color); }\n.llm-option__icon--upstage { background: var(--upstage-color); }\n.llm-option__icon--nvidia { background: var(--nvidia-color); }\n.llm-option__icon--arcee { background: var(--arcee-color); }\n.llm-option__icon--qwen { background: var(--qwen-color); }\n.llm-option__icon--mistral { background: var(--mistral-color); }\n.llm-option__icon--deepseek { background: var(--deepseek-color); }\n\n.llm-option__name {\n    font-size: 13px;\n    font-weight: 600;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 140px;\n}\n\n.llm-option__desc {\n    font-size: 11px;\n    color: var(--text-tertiary);\n}\n\n.cost-estimate {\n    background: var(--surface);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-lg);\n    padding: 14px;\n    margin-top: 16px;\n}\n\n.cost-estimate__title {\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--text-secondary);\n    margin-bottom: 10px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.cost-estimate__row {\n    display: flex;\n    justify-content: space-between;\n    padding: 6px 0;\n    font-size: 12px;\n}\n\n.cost-estimate__row--total {\n    border-top: 1px solid var(--border);\n    margin-top: 8px;\n    padding-top: 10px;\n    font-weight: 600;\n}\n\n.cost-estimate__label {\n    color: var(--text-secondary);\n}\n\n.cost-estimate__value {\n    font-weight: 500;\n}\n\n.cost-estimate__row--total .cost-estimate__value {\n    color: var(--partner-primary-600);\n    font-size: 14px;\n}\n\n.success-content {\n    text-align: center;\n    padding: 16px 0;\n}\n\n.success-content__icon {\n    width: 64px;\n    height: 64px;\n    background: var(--success-light);\n    border-radius: var(--radius-full);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 16px;\n    color: var(--success);\n}\n\n.success-content__title {\n    font-size: 18px;\n    font-weight: 700;\n    margin-bottom: 4px;\n}\n\n.success-content__subtitle {\n    font-size: 13px;\n    color: var(--text-secondary);\n}\n\n.invite-section {\n    margin-top: 20px;\n    text-align: left;\n}\n\n.invite-section__label {\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--text-tertiary);\n    text-transform: uppercase;\n    margin-bottom: 6px;\n}\n\n.invite-section__code {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 12px 16px;\n    background: var(--partner-primary-50);\n    border: 2px solid var(--partner-primary-200);\n    border-radius: var(--radius-lg);\n    margin-bottom: 12px;\n}\n\n.invite-section__code-text {\n    flex: 1;\n    font-size: 24px;\n    font-weight: 700;\n    font-family: monospace;\n    letter-spacing: 3px;\n    color: var(--partner-primary-600);\n    text-align: center;\n}\n\n.invite-section__url {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 12px;\n    background: var(--gray-50);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n}\n\n.invite-section__url input {\n    flex: 1;\n    border: none;\n    background: transparent;\n    font-size: 12px;\n    font-family: monospace;\n    color: var(--text-secondary);\n}\n\n.info-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n    margin-top: 16px;\n    padding: 14px;\n    background: var(--surface);\n    border-radius: var(--radius-lg);\n}\n\n.info-grid__item {\n    text-align: center;\n}\n\n.info-grid__value {\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.info-grid__label {\n    font-size: 10px;\n    color: var(--text-tertiary);\n    margin-top: 2px;\n}\n\n/* Dropdown Menu */\n.dropdown-menu {\n    position: fixed;\n    background: var(--background);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-lg);\n    min-width: 180px;\n    z-index: 1001;\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(-8px);\n    transition: all 0.2s;\n}\n\n.dropdown-menu--open {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n}\n\n.dropdown-menu__item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 14px;\n    font-size: 13px;\n    color: var(--text-primary);\n    cursor: pointer;\n    transition: all 0.15s;\n}\n\n.dropdown-menu__item:first-child {\n    border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n}\n\n.dropdown-menu__item:last-child {\n    border-radius: 0 0 var(--radius-lg) var(--radius-lg);\n}\n\n.dropdown-menu__item:hover {\n    background: var(--partner-primary-50);\n    color: var(--partner-primary-600);\n}\n\n.dropdown-menu__item--danger:hover {\n    background: var(--error-alert-bg);\n    color: var(--error);\n}\n\n.dropdown-menu__divider {\n    height: 1px;\n    background: var(--border);\n    margin: 4px 0;\n}\n\n/* Header Right Actions */\n.main-header__right {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.main-header__btn {\n    width: 36px;\n    height: 36px;\n    border: 1px solid var(--border);\n    background: var(--background);\n    border-radius: var(--radius-md);\n    cursor: pointer;\n    color: var(--text-secondary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n\n.main-header__btn:hover {\n    background: var(--surface);\n    border-color: var(--partner-primary-300);\n    color: var(--partner-primary-600);\n}\n\n.main-header__badge {\n    position: absolute;\n    top: -4px;\n    right: -4px;\n    min-width: 18px;\n    height: 18px;\n    background: var(--error);\n    color: white;\n    font-size: 10px;\n    font-weight: 600;\n    border-radius: var(--radius-full);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 4px;\n}\n\n/* Notification Dropdown */\n.notification-dropdown {\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    width: 320px;\n    background: var(--background);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-lg);\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n    z-index: 1000;\n    display: none;\n}\n\n.notification-dropdown--open {\n    display: block;\n}\n\n.notification-dropdown__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 16px;\n    border-bottom: 1px solid var(--border);\n}\n\n.notification-dropdown__title {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.notification-dropdown__action {\n    font-size: 12px;\n    color: var(--partner-primary-600);\n    cursor: pointer;\n}\n\n.notification-dropdown__action:hover {\n    text-decoration: underline;\n}\n\n.notification-dropdown__list {\n    max-height: 360px;\n    overflow-y: auto;\n}\n\n.notification-dropdown__empty {\n    padding: 40px 20px;\n    text-align: center;\n    color: var(--text-tertiary);\n    font-size: 13px;\n}\n\n.notification-dropdown__footer {\n    padding: 10px 16px;\n    border-top: 1px solid var(--border);\n    text-align: center;\n}\n\n.notification-dropdown__footer a {\n    font-size: 12px;\n    color: var(--partner-primary-600);\n    text-decoration: none;\n}\n\n.notification-dropdown__footer a:hover {\n    text-decoration: underline;\n}\n\n.notification-item {\n    padding: 12px 16px;\n    border-bottom: 1px solid var(--border);\n    cursor: pointer;\n    transition: background 0.15s;\n}\n\n.notification-item:hover {\n    background: var(--surface);\n}\n\n.notification-item:last-child {\n    border-bottom: none;\n}\n\n.notification-item--unread {\n    background: var(--partner-primary-50);\n}\n\n.notification-item--unread:hover {\n    background: var(--partner-primary-100);\n}\n\n.notification-item__text {\n    font-size: 13px;\n    color: var(--text-primary);\n    line-height: 1.5;\n}\n\n.notification-item__text strong {\n    font-weight: 600;\n}\n\n.notification-item__time {\n    font-size: 11px;\n    color: var(--text-tertiary);\n    margin-top: 4px;\n}\n\n.notification-group {\n    padding: 8px 16px 4px;\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--text-tertiary);\n    text-transform: uppercase;\n    background: var(--surface);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
